// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"9924eed3fb3521a66b029801ea939d4649bee7041be7f74190c6545351f8c46f","node_modules_react_index_js":"322dd505b94fc6c6f0343105da33504882dbd4ab7cf2f3e05c42087c11591e18"}[chunkId] + ".js";
};